(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('LibroSalarios', LibroSalarios);

    LibroSalarios.$inject = ['$scope', '$animationsSrv', 'TiposPlanillaService', 'logger', 'UserInfoService', 'moment', 'ReportesService'];

    function LibroSalarios($scope, $animationsSrv, TiposPlanillaService, logger, UserInfoService, moment, ReportesService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.tiposPlanilla = [];
        vm.libroSalarios = {
            tipoPlanillaId: -1,
            fechaDesde: moment().toDate(),
            fechaHasta: moment().toDate(),
            soloAsociacionSolidarista: false
        };

        vm.title = 'Libro Salarios';

        vm.fechaDesdeOptions = {
            showWeeks: true
        };

        vm.openFechaDesde = function(){
            vm.fechaDesdeOpened = !vm.fechaDesdeOpened;
        };

        vm.fechaHastaOptions = {
            showWeeks: true
        };

        vm.openFechaHasta = function(){
            vm.fechaHastaOpened = !vm.fechaHastaOpened;
        };

        getTiposPlanilla();

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        vm.tipoPlanillaChange = function(){
            validateTipo();         
        };
        
        function validateTipo(){
            if(vm.libroSalarios.tipoPlanillaId == -1){
                $scope.libroSalariosForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.libroSalariosForm.tipoPlanillaId.$setValidity("different", true);
            }
        }

        function validateFechaDesde(){
            if(!vm.libroSalarios.fechaDesde){
                $scope.libroSalariosForm.fechaDesde.$setValidity("required", false);
            }
            else{
                $scope.libroSalariosForm.fechaDesde.$setValidity("required", true);
            }
        };

        function validateFechaHasta(){
            if(!vm.libroSalarios.fechaHasta){
                $scope.libroSalariosForm.fechaHasta.$setValidity("required", false);
            }
            else{
                $scope.libroSalariosForm.fechaHasta.$setValidity("required", true);
            }
        };

        function doFormValidations(){
            validateTipo();
            validateFechaDesde();
            validateFechaHasta();
        };

        vm.generar = function() {
            var promise = null;
                
            $scope.submitted = true;

            doFormValidations();

            if($scope.libroSalariosForm.$valid){
                promise = ReportesService.getLibroSalarios(vm.libroSalarios.tipoPlanillaId, 
                    moment(vm.libroSalarios.fechaDesde).format('YYYY-MM-DD'), 
                    moment(vm.libroSalarios.fechaHasta).format('YYYY-MM-DD'),
                    vm.libroSalarios.soloAsociacionSolidarista);

                promise
                .then(function(response){
                    logger.success('Reporte Generado con éxito.');
                })
                .catch(function(error){
                    switch (error.status) {
                        case 500:
                            logger.error(`Hubo un error al generar el reporte: ${error.data.Message}`);
                            break;
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                        default:
                            logger.error('Hubo un error al generar el reporte');
                            break;
                    }
                }); 
            }
        };
        
        vm.limpiar = function(){
            $scope.submitted = false;
            // Reset the form model.
            vm.libroSalarios = {
                tipoPlanillaId: -1,
                fechaDesde: moment().toDate(),
                fechaHasta: moment().toDate()
            };
            
            // Set back to pristine.
            $scope.libroSalariosForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.libroSalariosForm.$setUntouched();
        }

    }
})();